import React from 'react';
import { createGlobalStyle } from 'styled-components';
import Markdown from './markdown';

type ArticleProps = {
  html: string;
  type: Page;
};

const ArticleGlobalStyle = createGlobalStyle`
  max-width: 100vw;
  .highlight {
    color: black !important;
    position: relative;
    display: inline-block;
    &:after {
      height: 100%;
      content: '';
      position: absolute;
      border-left: solid 0.1rem;
      left: -1rem;
      top: 0;
    }
  }
  .gatsby-highlight-code-line {
    background-color: #c4deff33;
    display: block;
    margin-right: -1em;
    margin-left: -1em;
    padding-right: 1em;
    padding-left: 0.75em;
    border-left: 0.25em solid #c4deff;
  }
  .gatsby-highlight {
    font-size: 1rem;
    margin: 0.5em 0;
    position: relative;
    letter-spacing: 0em;
    pre[class*='language-'] {
      margin: 0;
      border-radius: 0.5rem 0.5rem 0 0;
      padding-bottom: 0;
    }
    &:after {
      content: '';
      background: #2d2d2d;
      width: 100%;
      display: block;
      position: relative;
      height: 1rem;
      left: 0;
      border-radius: 0 0 0.5rem 0.5rem;
    }
  }
  .gatsby-code-title {
    position: relative;
    background: #5979aa;
    color: #fff;
    margin-bottom: -0.65em;
    padding: 0 1rem;
    font-size: 0.85em;
    font-weight: bold;
    border-radius: 3px 3px 0 0;
    display: table;
    &:after {
      content: '';
      background: #2d2d2d;
      width: 1rem;
      display: block;
      position: absolute;
      height: 1rem;
      left: 0;
      bottom: -0.5rem;
      z-index: -1;
    }
  }
  pre[class*='language-'].line-numbers {
    padding-left: 3em;
    min-width: calc(100% - 4em);
  }
  .line-numbers-rows {
    width: 2em !important;
    margin: 1em 0;
    > span::before {
      padding-right: 0.4em;
    }
  }
  .token.operator,
  .token.entity,
  .token.url,
  .token.variabl {
    background: none;
  }
  .gatsby-resp-image-wrapper {
    margin: 1rem;
  }

  .before-after {
    user-select: none;
    position: relative;
    margin: 1rem 0;
    span{
      margin: 0;
      width: var(--main-width);
    }
    a{
      pointer-events: none;
    }
    --pos-x: 50%;
    &::before{
      content: "";
      background: black;
      position: absolute;
      top: 0;
      height: 100%;
      width: 0.5rem;

      left: calc(var(--pos-x) - 0.25rem);
      z-index:999;
    }
    &::after{
      --size: 2rem;
      content: "";
      background: black;
      position: absolute;
      height: var(--size);
      width: var(--size);
      top: calc(50% - var(--size) / 2);
      left: calc(var(--pos-x) - var(--size) / 2);
      z-index:999;
      border-radius: 50%;
    }
  }
  .before{
    position:absolute;
    top: 0;
    width: var(--pos-x);
    max-width: var(--main-width);
    z-index: 99;
    overflow: hidden;
  }
`;

export const Article: React.VFC<ArticleProps> = ({ html }) => (
  <Markdown>
    <ArticleGlobalStyle />
    <div dangerouslySetInnerHTML={{ __html: html }} />
  </Markdown>
);

export const beforeAfterSlider = () => {
  const sliders = Array.from(
    document.getElementsByClassName('before-after'),
  ) as unknown as HTMLElement[];

  sliders.forEach((element) => {
    let prevMouseX = 0;
    let x = 50;
    const onMouseMove = (event: MouseEvent) => {
      const { left } = element.getBoundingClientRect();
      const mouseX = event.clientX - left;
      const moveDist = mouseX - prevMouseX;
      prevMouseX = mouseX;
      x += (moveDist / element.clientWidth) * 100;
      element.style.setProperty('--pos-x', `${Math.min(Math.max(x, 0), 100)}%`);
    };
    element.addEventListener(
      `mousedown`,
      (event: MouseEvent) => {
        const { left } = element.getBoundingClientRect();
        prevMouseX = event.clientX - left;
        element.addEventListener(`mousemove`, onMouseMove);
      },
      true,
    );
    element.addEventListener(
      `mouseup`,
      () => {
        element.removeEventListener(`mousemove`, onMouseMove);
      },
      true,
    );

    element.addEventListener(
      `touchmove`,
      (event) => {
        event.preventDefault();
        const { left } = element.getBoundingClientRect();
        if (event.changedTouches[0]) {
          const x =
            ((event.changedTouches[0].clientX - left) / element.clientWidth) *
            100;
          element.style.setProperty(
            '--pos-x',
            `${Math.min(Math.max(x, 0), 100)}%`,
          );
        }
      },
      true,
    );
  });
};
